__turbopack_context__.v({
  "className": "playfair_display_ee2d8585-module__q9YFMa__className",
  "variable": "playfair_display_ee2d8585-module__q9YFMa__variable",
});
